module.exports = __webpack_public_path__ + "img/investment_details_failed.c9135718.svg";